module.exports = __webpack_public_path__ + "img/personalize-packaging-no-matсhing.75b96507.svg";